export default __webpack_public_path__ + "static/media/plushback.911be53d.jpg";